const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginSvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M400.7,431.59c24.71-22.22,43.07-52.57,56.93-82,20.59-43.72,31.55-98.27,2.81-140.78-16.58-24.52-42.48-40-71.23-45.83-27.66-5.6-54.56-4.39-78.35-21.92-24.06-17.75-45-39.89-66.54-60.5-55.38-53-156-37.8-202.73,33.56s-34,164.06,11,207.06C93,359.81,149.38,367.36,194,397.56c22.11,15,37.57,37.07,61,50.24,27.25,15.31,60.66,21.59,91.36,13.77C367.26,456.24,385.22,445.51,400.7,431.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    },
    d: "M400.7,431.59c24.71-22.22,43.07-52.57,56.93-82,20.59-43.72,31.55-98.27,2.81-140.78-16.58-24.52-42.48-40-71.23-45.83-27.66-5.6-54.56-4.39-78.35-21.92-24.06-17.75-45-39.89-66.54-60.5-55.38-53-156-37.8-202.73,33.56s-34,164.06,11,207.06C93,359.81,149.38,367.36,194,397.56c22.11,15,37.57,37.07,61,50.24,27.25,15.31,60.66,21.59,91.36,13.77C367.26,456.24,385.22,445.51,400.7,431.59Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-3"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    y2: 407.52,
    x2: 442.89,
    y1: 443.85,
    x1: 446.76
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    d: "M442.87,408.54s-6.95-5.41-6.95-17.78,9.27-22.41,9.27-22.41,10.05,12.37,7.73,24.73S442.87,408.54,442.87,408.54Z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    y2: 380.22,
    x2: 444.66,
    y1: 407.52,
    x1: 442.89
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    d: "M450.33,441.17a161.91,161.91,0,0,1,12.31-25.07"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    d: "M459,422.67s-3.86-7.93,1.6-19,18.22-16,18.22-16,3.55,15.53-4,25.6S459,422.67,459,422.67Z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    y2: 399.54,
    x2: 473.07,
    y1: 422.67,
    x1: 459
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    d: "M440.49,444.41a100.59,100.59,0,0,0-8.5-20.09L426.58,415"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    d: "M430.93,422.21a26.45,26.45,0,0,1-25-5.22c-12-10.08-11.33-30.65-11.33-30.65s23.26-3.32,32.65,9.86A27.65,27.65,0,0,1,430.93,422.21Z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    y2: 393.48,
    x2: 403.36,
    y1: 422.21,
    x1: 430.93
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    height: 28.86,
    width: 29.43,
    y: 436.07,
    x: 430.05
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    height: 165.85,
    width: 196.86,
    y: 29,
    x: 213.45
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M254.31,122.24h-1.6l-.27-1.82H250.5l-.28,1.82h-1.45l1.61-10.07h2.32Zm-3.61-3.19h1.52l-.76-5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M256.55,112.17v7.77c0,.72.32,1,.82,1s.83-.26.83-1v-7.77h1.49v7.67c0,1.61-.8,2.53-2.36,2.53s-2.36-.92-2.36-2.53v-7.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M260.31,112.17h4.89v1.44h-1.65v8.63H262v-8.63h-1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M267.48,122.24h-1.59V112.17h1.59v4.32h1.79v-4.32h1.62v10.07h-1.62v-4.31h-1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M273.62,116.41h2.17v1.44h-2.17v3h2.73v1.44H272V112.17h4.31v1.44h-2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M278.74,115v7.29h-1.42V112.17h2l1.63,6v-6h1.41v10.07h-1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M283,112.17h4.9v1.44h-1.66v8.63h-1.58v-8.63H283Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M288.6,112.17h1.58v10.07H288.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M295.92,118.49v1.34c0,1.61-.8,2.53-2.36,2.53s-2.36-.92-2.36-2.53v-5.24c0-1.62.81-2.54,2.36-2.54s2.36.92,2.36,2.54v1h-1.49v-1.08c0-.72-.32-1-.82-1s-.82.28-.82,1v5.44c0,.72.31,1,.82,1s.82-.25.82-1v-1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M302,122.24h-1.6l-.27-1.82H298.2l-.28,1.82h-1.45l1.61-10.07h2.32Zm-3.61-3.19h1.52l-.76-5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M301.73,112.17h4.9v1.44H305v8.63h-1.58v-8.63h-1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M308.9,116.41h2.17v1.44H308.9v3h2.74v1.44h-4.32V112.17h4.32v1.44H308.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M316.33,118.9l-2-6.73H316l1.21,4.59,1.21-4.59h1.51l-2,6.73v3.34h-1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M320.2,114.59a2.4,2.4,0,1,1,4.8,0v5.24a2.4,2.4,0,1,1-4.8,0Zm1.58,5.34c0,.72.32,1,.82,1s.82-.27.82-1v-5.44c0-.72-.32-1-.82-1s-.82.28-.82,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M327.53,112.17v7.77c0,.72.32,1,.82,1s.82-.26.82-1v-7.77h1.5v7.67c0,1.61-.8,2.53-2.36,2.53s-2.36-.92-2.36-2.53v-7.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M335.06,122.24a3,3,0,0,1-.14-1.24v-1.58c0-.93-.32-1.28-1-1.28h-.55v4.1h-1.58V112.17h2.39c1.64,0,2.34.76,2.34,2.32v.79a2,2,0,0,1-1,2c.79.33,1.05,1.09,1.05,2.14V121a2.91,2.91,0,0,0,.17,1.22Zm-1.73-8.63v3.09H334c.59,0,.95-.26.95-1.06v-1c0-.72-.24-1-.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M344.89,122.24h-1.6l-.27-1.82h-1.95l-.27,1.82h-1.45L341,112.17h2.32Zm-3.61-3.19h1.52L342,114Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M350.2,118.49v1.34c0,1.61-.81,2.53-2.36,2.53s-2.36-.92-2.36-2.53v-5.24c0-1.62.8-2.54,2.36-2.54s2.36.92,2.36,2.54v1h-1.5v-1.08c0-.72-.32-1-.82-1s-.82.28-.82,1v5.44c0,.72.32,1,.82,1s.82-.25.82-1v-1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M355.75,118.49v1.34c0,1.61-.8,2.53-2.36,2.53s-2.36-.92-2.36-2.53v-5.24c0-1.62.81-2.54,2.36-2.54s2.36.92,2.36,2.54v1h-1.5v-1.08c0-.72-.31-1-.82-1s-.82.28-.82,1v5.44c0,.72.32,1,.82,1s.82-.25.82-1v-1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M356.58,114.59a2.41,2.41,0,1,1,4.81,0v5.24a2.41,2.41,0,1,1-4.81,0Zm1.59,5.34c0,.72.31,1,.82,1s.82-.27.82-1v-5.44c0-.72-.32-1-.82-1s-.82.28-.82,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M363.92,112.17v7.77c0,.72.32,1,.82,1s.82-.26.82-1v-7.77h1.5v7.67c0,1.61-.8,2.53-2.36,2.53s-2.36-.92-2.36-2.53v-7.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M369.55,115v7.29h-1.42V112.17h2l1.63,6v-6h1.41v10.07h-1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M373.82,112.17h4.9v1.44h-1.66v8.63h-1.58v-8.63h-1.66Z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#d2232a"
    },
    transform: "translate(186.35 374.16) rotate(-80.85)",
    r: 22.58,
    cy: 77.7,
    cx: 312.8
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M322.65,72.49a9.85,9.85,0,1,1-9.85-9.85A9.85,9.85,0,0,1,322.65,72.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M296.59,93.4a22.56,22.56,0,0,0,32.42,0v-.65a8.68,8.68,0,0,0-8.68-8.69H305.28a8.69,8.69,0,0,0-8.69,8.69Z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.9853323101997375px"
    },
    height: 16.56,
    width: 136.22,
    y: 140.39,
    x: 244.25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#d2232a",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.9853323101997375px"
    },
    height: 16.56,
    width: 136.22,
    y: 165.22,
    x: 244.25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdbdbd"
    },
    d: "M289.94,149.14v1h-2.46v3.58h3v1h-4.14V144.68h4.14v1h-3v3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdbdbd"
    },
    d: "M292.53,154.76h-1V144.68H293l2.33,7.28v-7.28h1v10.08h-1.17l-2.58-8.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdbdbd"
    },
    d: "M298.89,154.76V145.7H297v-1h4.84v1H300v9.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdbdbd"
    },
    d: "M306.23,149.14v1h-2.46v3.58h3v1h-4.14V144.68h4.14v1h-3v3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdbdbd"
    },
    d: "M310.07,144.68c1.59,0,2.25.81,2.25,2.3v.82a1.89,1.89,0,0,1-1.25,2.08c.92.27,1.26,1,1.26,2.1v1.57a2.64,2.64,0,0,0,.2,1.21H311.4a2.65,2.65,0,0,1-.19-1.23V152c0-1.14-.53-1.5-1.47-1.5H309v4.31h-1.12V144.68Zm-.28,4.75c.89,0,1.42-.29,1.42-1.38v-1c0-.9-.33-1.38-1.17-1.38H309v3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdbdbd"
    },
    d: "M320.18,147.11V148h-1.07v-1c0-.91-.36-1.46-1.18-1.46s-1.18.55-1.18,1.46v5.32c0,.91.37,1.46,1.18,1.46s1.18-.55,1.18-1.46v-1.31h1.07v1.25c0,1.53-.73,2.54-2.28,2.54s-2.26-1-2.26-2.54v-5.21c0-1.52.72-2.53,2.26-2.53S320.18,145.59,320.18,147.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdbdbd"
    },
    d: "M321.11,147.11c0-1.54.76-2.53,2.3-2.53s2.32,1,2.32,2.53v5.21c0,1.53-.76,2.54-2.32,2.54s-2.3-1-2.3-2.54Zm1.11,5.27c0,.92.39,1.46,1.19,1.46s1.2-.54,1.2-1.46v-5.32c0-.91-.38-1.46-1.2-1.46s-1.19.55-1.19,1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdbdbd"
    },
    d: "M329.15,144.68c1.57,0,2.29.95,2.29,2.51v5.08c0,1.54-.72,2.49-2.29,2.49h-2.36V144.68Zm0,9c.8,0,1.19-.5,1.19-1.42v-5.18c0-.92-.39-1.43-1.21-1.43h-1.21v8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdbdbd"
    },
    d: "M336.07,149.14v1h-2.46v3.58h3v1h-4.15V144.68h4.15v1h-3v3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M303.2,169.6c1.56,0,2.28,1,2.28,2.51v5.08c0,1.54-.72,2.49-2.28,2.49h-2.37V169.6Zm0,9.06c.81,0,1.2-.51,1.2-1.43v-5.18c0-.92-.39-1.42-1.21-1.42H302v8Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M306.45,172c0-1.54.76-2.54,2.3-2.54s2.32,1,2.32,2.54v5.21a2.22,2.22,0,0,1-2.32,2.53c-1.54,0-2.3-1-2.3-2.53Zm1.1,5.27c0,.92.39,1.45,1.2,1.45s1.19-.53,1.19-1.45V172c0-.91-.37-1.46-1.19-1.46s-1.2.55-1.2,1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M313.12,179.68h-1V169.6h1.42l2.33,7.29V169.6h1v10.08H315.7l-2.58-8.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M321.6,174.07v1h-2.46v3.59h3v1H318V169.6h4.15v1h-3v3.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#d2232a",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    height: 8.02,
    width: 196.86,
    y: 29,
    x: 213.45
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    y2: 283.79,
    x2: 81.72,
    y1: 285.27,
    x1: 81.72
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px",
      strokeDasharray: "2.9267220497131348,2.9267220497131348"
    },
    d: "M81.72,280.86V154.07a19.5,19.5,0,0,1,19.51-19.5H194"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    y2: 134.57,
    x2: 196.98,
    y1: 134.57,
    x1: 195.51
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "206.73 135.38 190.79 126.17 190.79 144.58 206.73 135.38"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    y2: 408.76,
    x2: 360.38,
    y1: 408.76,
    x1: 358.9
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px",
      strokeDasharray: "2.9297451972961426,2.9297451972961426"
    },
    d: "M363.31,408.76h5.47a19.57,19.57,0,0,0,19.57-19.57v-185"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    y2: 201.26,
    x2: 388.35,
    y1: 202.73,
    x1: 388.35
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "353.32 407.9 369.26 417.1 369.26 398.69 353.32 407.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    d: "M269.79,287.86a10,10,0,0,1,8.88-5.35h85.55s6.18,0,4.33,11.75-27.21,83.49-33.4,105.13-7.42,67.41-7.42,67.41H225.07S233.3,357.53,269.79,287.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    d: "M349.38,302.92c-8.65,20.18-27,100-29.92,163.88h8.27S329,421,335.15,399.39s31.54-93.38,33.4-105.13-4.33-11.75-4.33-11.75S356.31,286.74,349.38,302.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    d: "M186.7,284.13s-15.7-1.91-26.07-12.81,22.54-49.77,40.11-58.93,24.81-6.65,43.65,7.24,37.23,36.18,37,51.13-8.37,22.1,3,29.47,43.55,28.3,48.25,42.68-3.45,32.27-22.32,42-49.83,9.28-79.65-.36S194.36,344.41,198.2,332s14-20.94,10.94-30.38S186.7,284.13,186.7,284.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M200.16,327s-16.24-2.26-23.74,2.59-44.56,68.19-44.56,68.19l-20.47-27.55L93.64,378.2s8.32,32.2,18,48.22,15.2,17.64,18.52,17.11c9.88-1.57,38.5-34.68,38.5-34.68l10.4,34.6L172,468.6H303.5L287.55,442s20.81-96,15.51-106.17S266.88,327,257.17,327h-27.8a69.3,69.3,0,0,1-12.79,1.32A161.22,161.22,0,0,1,200.16,327Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M288,330.24l.27.11-2.52,6.42-.28-.11Zm-.69,7.14.27.11,2.53-6.42-.28-.11Zm11.47,20.43-.29-.08-1.11,3.95h.31Zm1.9.54-.29-.08-1,3.41h.3Zm-12,.22.94,3.11h.31l-1-3.2Zm2.18-.65-.29.08,1.11,3.68h.31Zm8.05-14.69,3.43-6-.25-.15-3.43,6Zm1.72,1,3.21-5.61c0-.17,0-.32-.06-.48l-3.41,5.95Zm2.25,8.53.57-.75.06-.55-.87,1.12Zm-8.49-6.09,4.78,5,.21-.2-4.78-5ZM292.88,348l4.77,5,.22-.2-4.78-5Zm-5.27,0,.08-.29L284,346.8v.3Zm-3.66-3,4.15,1.05.07-.29L284,344.76Zm4.63,8.93-.09-.28L284,355.21v.31Zm-.71-2.16-3.92,1.3v.31l4-1.33Zm-2.17,55.87,2.52-6.42-.27-.11-2.53,6.42Zm4.08-5.81-2.52,6.42.27.11,2.53-6.42Zm-.13,30.1-.77-2.57-.29.08.94,3.1Zm5-43.18-.28.1,2.34,6.49.06,0,.09-.45Zm1.57-.57,1.23,3.39c0-.19.07-.38.1-.58l-1.05-2.91Zm4.38-16.9.16.53.09-.6Zm-6.58-.39-.4,6.88.29,0,.4-6.89Zm1.57,7,.29,0,.4-6.89-.29,0Zm-8.41-7.3.14-.26-3.4-1.83v.34Zm-3.26-4,4.19,2.25.14-.26L284,366.33Zm2.62,10.41-.19-.22L284,379v.39Zm-1.29-1.49-.19-.23-1.14,1v.39ZM284,387.34v.31l6.22-2.43-.11-.27Zm0-2.12v.32l5.5-2.15-.11-.28Zm3.67,12.52.07-.29-3.74-.84v.3Zm.43-1.92.07-.29-4.17-.94v.3ZM287.61,419l.08-.28-3.74-.95v.31ZM284,416l4.15,1.06.07-.29L284,415.71Zm4.63,8.93-.09-.28L284,426.15v.32Zm-.62-1.87-.09-.28L284,424.08v.31Zm8.89-58.62.79-2.77h-.31l-.76,2.69Zm2.83-2.77h-.3l-.91,3.22.28.09Zm-9.1,3.49.29-.08-1-3.41h-.31Zm2.17-.65-.85-2.84h-.31l.88,2.93Zm1.65,95.35,2.34,6.48.28-.1-2.34-6.48Zm4.47,5.71-2.34-6.48-.28.1,2.35,6.48Zm3.31,1.6-.29-.08-.42,1.5h.31ZM284,439.85l3.26,1.75.14-.26-3.4-1.83Zm0-2.24L288,439.8l.06-.3L284,437.28ZM286.57,448l-.19-.23L284,449.9v.38Zm-1.29-1.5-.19-.22-1.14,1v.39Zm4.78,9.36L284,458.28v.32l6.22-2.44Zm-6.11.59,5.5-2.15-.11-.27-5.39,2.1Zm0,11.07v.31l3.31.74h.38l.05-.2Zm4.1-.79.07-.29-4.17-.94v.31Zm-73.57-130.1.27.11,2.53-6.42-.28-.11Zm1.83.72.28.11,2.52-6.42-.27-.11Zm64.62,8.95,3,.77v-.3l-2.95-.75Zm.56-2.19-.08.28,2.54.65v-.31ZM284,355.52v-.31l-2,.67.09.28ZM281.32,354l.09.28,2.54-.84v-.31ZM276,361.68h.34l1.3-2.26-.25-.15Zm2.28,0h.34l.73-1.28-.25-.15Zm-14.87-2.76-.23.19,2.11,2.57h.38Zm1.3-1.06,3.13,3.82h.38l-3.28-4Zm-7.46,3.37-.27.1.12.35h.32Zm1.58-.57.37,1h.31l-.4-1.12Zm-10.82,1,.85-3.35-.29-.07-.87,3.42Zm2.47-2.94-.75,2.94H250l.73-2.86Zm-22.67-.93-.29-.08-1.12,3.95h.31Zm1.89.54-.28-.08-1,3.41h.31Zm-12,.22.94,3.11h.31l-1-3.2Zm2.17-.65-.28.08,1.11,3.68h.3Zm8.06-14.69,3.43-6-.26-.15-3.43,6Zm1.46.84.25.14,3.43-6-.26-.15Zm39.13,4.4,6.35,2.69.11-.27-6.35-2.69Zm-.77,1.81,6.35,2.69.11-.27L267.81,350Zm5.35-10.36.28.08,1.88-6.63-.29-.09Zm1.89.54.29.08,1.87-6.64-.28-.08ZM264.67,328.1l2,6.6.28-.08L265,328Zm1.88-.57,2,6.6.28-.08-2-6.6ZM244.76,355.8l-2-6.6-.28.08,2,6.61Zm1.89-.57-2-6.6-.29.08,2,6.61Zm7.8-3.82,6.83-1,0-.29-6.83,1Zm.28,1.95,6.83-1,0-.29-6.83,1Zm5-8.41.29.07,1.54-6.72-.29-.07Zm3.46-6.28-1.54,6.72.29.07,1.54-6.72ZM239,341.12l.25.16,3.69-5.83-.25-.15Zm5.61-4.61-.25-.16-3.69,5.83.25.16Zm-6.41-6.71,6.32-2.76,0-.07h-.54l-5.87,2.56Zm.67,1.53.12.27,6.32-2.75-.12-.27Zm-6-4.36h-.31L231,332.39l.29.08Zm-3.45,5,1.4-5h-.31l-1.38,4.88Zm27.06-2.88L255.8,327h-.31l.65,2.16Zm-2.17.65.29-.08-.8-2.65h-.31Zm-22.64,22.86.23.18,4.2-5.47-.24-.18Zm1.56,1.2.24.18,4.19-5.48-.23-.18Zm-9.82-7.11,4.78,5,.22-.2-4.78-5ZM221.93,348l4.78,5,.21-.2-4.77-5Zm26.18-8.84-.12.27,6.35,2.7.12-.28Zm.65-1.54,6.35,2.69.12-.27-6.35-2.69ZM216.67,348l.07-.29L213,346.8v.3Zm-3.66-3,4.14,1.05.08-.29L213,344.76Zm4.63,8.93-.1-.28L213,355.21v.31Zm-.72-2.16-3.91,1.3v.31l4-1.33Zm.08,49.34-2.52,6.42.27.11,2.53-6.42Zm1.84.72-2.53,6.42.28.11,2.52-6.42Zm62.3-34.51,2.81,1.52v-.34l-2.67-1.44Zm1.07-2-.14.25,1.88,1v-.34ZM284,379l-2.79,2.42.19.22,2.6-2.25Zm-3.89,1.15,3.89-3.36v-.39l-4.08,3.52Zm3.58,7.36.1.28.21-.09v-.31Zm-.72-1.83.1.27.93-.36v-.32Zm1,11-3-.68-.07.29,3.06.69Zm0-2-2.56-.58-.06.29,2.62.59Zm0,23.15L281,417l-.07.29,3,.77Zm-2.46-2.66-.08.29L284,416v-.3ZM284,426.47v-.32l-2,.67.09.28Zm0-2.08v-.31l-2.63.87.09.28ZM243.4,365.18l-6.35-2.7-.11.27,6.35,2.7Zm-7.23-.61,6.35,2.69.11-.27-6.35-2.69Zm41.45,65.79-.25-.14L276,432.63h.34Zm1.71,1-.25-.15-.82,1.44h.34Zm-16.17-1.29,2.11,2.58h.38l-2.26-2.77Zm1.53-1.25,3.13,3.83h.38l-3.28-4Zm-7.46,3.38-.27.1.12.35h.32Zm1.58-.57.37,1h.31l-.4-1.12Zm-10-2.33-.29-.08-.87,3.43H248Zm1.62.41-.75,2.94H250l.73-2.87Zm-22.67-.94-.29-.08-1.12,4h.31Zm1.89.54-.28-.08-1,3.42h.31Zm-12,.22.94,3.12h.31l-1-3.2Zm1.89-.56,1.11,3.68h.3l-1.13-3.77Zm11.51-20.9-3.43,6,.26.15,3.43-6Zm2,1.12-.26-.15-3.42,6,.25.15Zm27.89-32.86L256.54,371l-.22.19,4.36,5.34Zm-1.52,1.25L255,372.22l-.23.19,4.37,5.34Zm-10.81-2.92,2.34,6.48.28-.1-2.34-6.48Zm1.86-.67,2.34,6.48.27-.1-2.34-6.48Zm24.49,47.86-6.35-2.69-.11.27,6.35,2.69Zm-.77,1.82-6.35-2.7-.11.28,6.35,2.69Zm.76-19.42-1.87,6.64.28.08,1.88-6.64Zm2.18.62-.28-.08-1.88,6.63.29.08Zm-10.17.71-2-6.6-.28.08,2,6.61Zm1.89-.57-2-6.6-.29.08,2,6.61Zm-20-17.27-3.43,6,.25.14,3.43-6Zm-1.46-.83-.26-.15-3.42,6,.25.14Zm-11.65,5.45L231.37,387l-.23.19,4.37,5.34Zm1.52-1.25-4.36-5.34-.23.19,4.36,5.34Zm-13.8-2.17,2.34,6.49.28-.1-2.35-6.49Zm1.85-.67,2.34,6.49.28-.1-2.34-6.49ZM273,393.52l.29.07,1.7-6.68-.29-.08Zm3.9-6.13-.29-.07-1.7,6.68.29.07ZM265.62,393l-6.35-2.69-.11.27,6.35,2.7Zm.77-1.81L260,388.5l-.11.27,6.35,2.69Zm-21.63,35.56-2-6.61-.28.09,2,6.6Zm1.89-.57-2-6.61-.29.09,2,6.6Zm14.63-4.79,0-.29-6.83,1,0,.29Zm.28,1.95,0-.29-6.83,1,0,.29ZM260,416l1.54-6.72-.29-.07-1.54,6.73Zm1.92.44,1.54-6.72-.29-.07-1.54,6.73Zm-19-10-.25-.16L239,412.07l.25.16Zm1.67,1.05-.25-.16-3.69,5.83.25.16Zm-.09-9.47-.11-.27-6.33,2.76.12.27Zm.79,1.81-.12-.27-6.32,2.76.12.27Zm-12.15-3-.28-.09L231,403.33l.29.08Zm-3.77,6.1,1.87-6.64-.28-.08-1.88,6.64ZM256.42,400l-2-6.6-.29.08,2,6.61ZM252.27,394l2,6.6.29-.08-2-6.6Zm-9.59-17-5.51,4.16.18.23,5.51-4.15Zm-4.14,6,5.5-4.16-.17-.23-5.51,4.15Zm-4.76-5.71-1.91-6.63-.29.09,1.92,6.62Zm-4.09-6L231.6,378l.29-.08L230,371.27Zm-6.58-.39-.4,6.88.29,0,.4-6.89Zm1.56,7,.3,0,.4-6.89-.3,0ZM236,418.21l-.24-.18-4.19,5.48.23.18Zm1.56,1.2-.23-.18-4.2,5.48.24.18Zm-14.25-1.82,4.78,5,.22-.21-4.78-5ZM221.93,419l4.78,5,.21-.2-4.77-5Zm50.22-38.41-.23-.18-4.34,5.36.23.19Zm-1.76-1.42-4.34,5.36.23.19,4.33-5.37ZM271.6,369l-.29,0-.78,6.85.3,0Zm-2.25-.26-.77,6.86.29,0,.77-6.85Zm-14.89,44.1-6.35-2.69-.12.27,6.35,2.69Zm-5.7-4.24,6.35,2.69.12-.27-6.35-2.69Zm-32.49-37.91.14-.26-3.4-1.83v.34Zm-3.26-4,4.19,2.25.14-.26L213,366.33Zm2.62,10.41-.2-.22L213,379v.39Zm-1.29-1.49-.2-.23-1.13,1v.39Zm4.77,9.36-6.1,2.39v.31l6.21-2.43Zm-.61-1.56-.1-.28L213,385.22v.32Zm-1.82,14.35.06-.29-3.73-.84v.3ZM213,394.89l4.1.93.07-.29-4.17-.94ZM216.67,419l.07-.28-3.73-.95v.31ZM213,416l4.14,1.06.08-.29L213,415.71Zm4.63,8.93-.1-.28L213,426.15v.32Zm-.62-1.87-.1-.28L213,424.08v.31Zm56.92-57.81.25.14,2.13-3.72H276Zm1.71,1,.25.14,2.7-4.7h-.34Zm-7.89-2-2.11-2.58h-.38l2.26,2.76Zm1.3-1.06.23-.19-1.09-1.33h-.38Zm-9.48,4.52-2.18-6h-.32l2.22,6.14Zm1.57-.57.28-.1-1.94-5.37h-.31Zm-14.3-2.21.29.07.85-3.33h-.31Zm1.91.49.29.07,1-3.82h-.31Zm-22.85-1,.78-2.77h-.31l-.76,2.69Zm2.83-2.77h-.31l-.91,3.22.29.09Zm-9.1,3.49.28-.08-1-3.41h-.31Zm2.17-.65-.86-2.84h-.3l.87,2.93Zm59.47,73.55-.14.26,2.81,1.52v-.34Zm.93-1.73-.14.26,1.88,1v-.33ZM284,450.28v-.38l-2.79,2.41.19.22Zm0-2.6v-.39l-4.08,3.53.19.22Zm-.31,10.72.1.28.21-.08v-.32Zm-.72-1.83.1.28.93-.37v-.32Zm-2,10.31-.07.29,3.06.69v-.31Zm3-1.35-2.56-.58-.06.29,2.62.6ZM243.4,436.12l-6.35-2.69-.11.27,6.35,2.69Zm-7.23-.61,6.35,2.7.11-.28-6.35-2.69Zm20.15,6.59,4.36,5.34.23-.19-4.37-5.33Zm3.07,6.4L255,443.17l-.23.18,4.37,5.34ZM251.2,452l-2.34-6.49-.28.1,2.34,6.49Zm1.85-.67-2.34-6.49-.27.1,2.34,6.49Zm-4,7.51-.25-.15-3.43,6,.25.15Zm-1.71-1-.26-.14-3.42,6,.25.15Zm-11.65,5.45L231.37,458l-.23.18,4.37,5.34Zm1.52-1.25-4.36-5.33-.23.18,4.36,5.34Zm-11.18,4.22-2.35-6.48-.27.1,2.34,6.48Zm1.85-.67-2.34-6.48-.28.1,2.34,6.48Zm47-7.73-.29-.07-1.7,6.68.29.07Zm1.91.48-.29-.07-1.7,6.69.29.07ZM265.62,464l-6.35-2.69-.11.27,6.35,2.69Zm.77-1.82L260,459.44l-.11.27,6.35,2.7Zm-33.54,5.51-.28,1h.31l.25-.88Zm-1.62-.46-.28-.08-.43,1.5h.31Zm22.92-2.76,1.26,4.18h.31l-1.28-4.27Zm-1.6.48-.28.08,1.08,3.62h.31Zm-9.69-16.63-.18-.23-5.51,4.15.18.24Zm1.18,1.58-.17-.24-5.51,4.15.18.24Zm-10.54-1.47.28-.09-1.91-6.62-.29.08Zm-1.61.46L230,442.22l-.28.08,1.91,6.62Zm-8.89,0,.4-6.88-.29,0-.4,6.89Zm2,.12.4-6.89h-.3l-.4,6.88Zm47.18,2.58-.23-.19-4.34,5.36.23.19Zm-1.76-1.43-4.34,5.36.23.19,4.33-5.36Zm1.21-10.16-.29,0-.78,6.85.3,0Zm-2.25-.25-.77,6.85.29,0,.77-6.86Zm-53.08,1.94.14-.26-3.4-1.83v.34Zm1.07-2L213,437.28v.33l4.19,2.26ZM215.63,448l-.2-.23L213,449.89v.39Zm-1.29-1.5-.2-.22-1.13,1v.39Zm4.77,9.36-6.1,2.39v.32l6.21-2.44Zm-6.1.59,5.49-2.15-.1-.27-5.39,2.1Zm0,11.07v.31l3.31.74h.37l.05-.2Zm4.1-.79.07-.29-4.17-.94v.31Zm57.08-30.41,2.13-3.72H276l-2,3.57Zm4.07-3.72-2.61,4.55.25.15,2.7-4.7Zm-10.73,2.76.23-.19-2.11-2.57h-.38Zm1.53-1.25.23-.19-1.09-1.32h-.38Zm-9.48,4.52-2.18-6h-.32l2.22,6.13Zm1.57-.56.28-.11-1.94-5.36h-.31Zm-14-2.14.85-3.33h-.31l-.83,3.26Zm1.62.41.29.07,1-3.81h-.31Zm-22.85-1,.78-2.76h-.31l-.76,2.68Zm2.52-2.76-.91,3.22.29.08.93-3.3Zm-8.79,3.49.28-.09-1-3.4h-.31Zm1.88-.57.29-.08-.86-2.84h-.3ZM210,346.33l3,.77v-.3l-2.95-.75Zm.56-2.19-.07.28,2.54.65v-.31ZM213,355.52v-.31l-2,.67.1.28ZM210.38,354l.09.28,2.54-.84v-.31ZM205,361.68h.34l1.3-2.26-.26-.15Zm2.27,0h.34l.74-1.28-.26-.15Zm-14.86-2.76-.23.19,2.11,2.57h.38Zm1.3-1.06,3.12,3.82h.39l-3.28-4Zm-7.46,3.37-.28.1.13.35h.31Zm1.58-.57.36,1h.32l-.4-1.12Zm-10.83,1,.85-3.35-.28-.07-.87,3.42Zm2.48-2.94-.75,2.94h.31l.72-2.86Zm-23.77,2.94,1.09-3.87-.28-.08-1.12,3.95Zm3-3.33-.29-.08-1,3.41h.31Zm38.78-9.88,6.35,2.69.12-.27-6.35-2.69Zm-.77,1.81L203.1,353l.12-.27L196.87,350Zm5.35-10.36.29.08,1.87-6.63-.28-.09Zm1.9.54.28.08,1.88-6.64-.28-.08ZM193.72,328.1l2,6.6.28-.08L194,328Zm1.89-.57,2,6.6.28-.08-2-6.6Zm-24.06,21.75,2,6.61.28-.09-2-6.6Zm4.16,6-2-6.6-.28.08,2,6.61Zm7.8-3.82,6.83-1,0-.29-6.83,1Zm.23,1.66,0,.29,6.83-1,0-.29Zm6.86-14.77-.29-.07L188.78,345l.28.07Zm1.64.37-1.54,6.72.28.07,1.54-6.72ZM168,341.12l.25.16,3.69-5.83-.25-.15Zm1.67,1.06.25.16,3.69-5.83-.25-.16Zm15.78-13.13-.64-2.13-.3,0,.66,2.17Zm-2.17.65.28-.08-.71-2.38-.29.06Zm-22.64,22.86.23.18,4.19-5.47-.23-.18Zm6-4.1-.24-.18-4.19,5.48.24.18Zm10.5-9.29-.11.27,6.35,2.7.11-.28Zm.66-1.54,6.35,2.69.11-.27-6.35-2.69Zm-31.76,63.55-2.52,6.42.27.11,2.52-6.42Zm1.83.72-2.52,6.42.27.11,2.53-6.42Zm62.3-34.51,2.82,1.52v-.34l-2.68-1.44Zm1.08-2-.14.25,1.88,1v-.34ZM213,379l-2.8,2.42.2.22,2.6-2.25Zm-3.89,1.15,3.89-3.36v-.39l-4.08,3.52Zm3.57,7.36.11.28.21-.09v-.31Zm.32-2.24-1,.41.11.27.93-.36Zm0,11.39-3-.68-.06.29,3.06.69Zm-2.56-2.6-.07.29,2.63.59v-.3ZM213,417.74l-2.95-.75-.08.29,3,.77Zm-2.47-2.66-.07.29L213,416v-.3ZM213,426.47v-.32l-2,.67.1.28Zm0-2.08v-.31l-2.63.87.09.28Zm-47-61.64,6.35,2.7.12-.27-6.35-2.7Zm-.77,1.82,6.35,2.69.12-.27-6.35-2.69Zm41.46,65.79-.26-.14L205,432.63h.34Zm1.71,1-.26-.15-.82,1.44h.34Zm-16.17-1.29,2.11,2.58h.38l-2.26-2.77Zm1.53-1.25,3.12,3.83h.39l-3.28-4Zm-7.46,3.38-.28.1.13.35h.31Zm1.58-.57.36,1h.32l-.4-1.12Zm-11.13,1h.3l.85-3.35-.28-.08Zm2.78-2.94-.75,2.94h.31l.72-2.87ZM147,429.43l-.28.08.55,1.82.24-.22Zm1.89-.57-.29.09.27.86.23-.23Zm11.49-20.67-.26-.14-3.43,6,.26.15Zm-1.72,7,3.43-6-.26-.15-3.43,6ZM190,376.31,185.6,371l-.23.19,4.37,5.34Zm-1.53,1.25-4.37-5.34-.22.19,4.36,5.34Zm-10.8-2.92,2.34,6.48.28-.1-2.34-6.48Zm1.85-.67,2.34,6.48.28-.1-2.34-6.48ZM204,421.83l-6.35-2.69-.12.27,6.35,2.69Zm-.77,1.82-6.35-2.7-.12.28,6.35,2.69Zm.76-19.42-1.88,6.64.29.08,1.87-6.64Zm2.18.62-.28-.08L204,411.4l.28.08Zm-10.17.71-2-6.6-.28.08,2,6.61Zm1.89-.57-2-6.6-.28.08,2,6.61Zm-20-17.27-3.43,6,.26.14,3.43-6Zm-1.71-1-3.43,6,.26.14,3.43-6Zm-16,.45,4.37,5.34.22-.19L160.43,387Zm1.52-1.25,4.37,5.34.23-.19L162,385.75Zm-9.21,3,2.34,6.49.28-.1-2.34-6.49Zm1.86-.67,2.34,6.49.27-.1-2.34-6.49ZM202,393.52l.29.07,1.69-6.68-.28-.08Zm3.9-6.13-.29-.07-1.7,6.68.29.07ZM194.68,393l-6.35-2.69-.12.27,6.35,2.7Zm.77-1.81-6.35-2.69-.12.27,6.35,2.69Zm-22,28.47,2,6.6.28-.08-2-6.61Zm16.9,1.73,0-.29-6.83,1,0,.29Zm.27,1.95,0-.29-6.83,1,0,.29ZM189.06,416l1.54-6.72-.29-.07-1.53,6.73Zm1.92.44,1.54-6.72-.28-.07-1.54,6.73Zm-19.26-10.16-2.6,4.11.11.38L172,406.4Zm1.67,1.05-3.52,5.56.11.37,3.66-5.77Zm-6.28-6.82.12.27,6.32-2.76-.12-.27Zm7.23-.68-.12-.27-6.32,2.76.11.27Zm-12.15-3-.29-.09L160,403.33l.28.08Zm-3.78,6.1,1.88-6.64-.28-.08-1.88,6.64ZM185.48,400l-2-6.6-.28.08,2,6.61ZM181.32,394l2,6.6.28-.08-2-6.6Zm-9.59-17-5.5,4.16.18.23,5.5-4.15Zm-4.32,5.73.18.24,5.51-4.16-.18-.23Zm-6.77-12,1.91,6.62.29-.08-1.92-6.63Zm-1.89.54,1.91,6.63.28-.08L159,371.27Zm-7,6.49.3,0,.4-6.89h-.3Zm2.66-6.75-.29,0-.4,6.89.29,0Zm2.42,50.69-4.22-4.39-.21.2,4.23,4.4Zm-5.64-3L151,419l4.28,4.45.2-.21Zm50-38.2-.23-.18-4.33,5.36.23.19Zm-1.76-1.42-4.34,5.36.23.19,4.34-5.37ZM200.66,369l-.3,0-.77,6.85.29,0Zm-2.26-.26-.77,6.86.3,0,.77-6.85Zm-14.89,44.1-6.35-2.69-.11.27,6.35,2.69Zm.77-1.82-6.35-2.69-.11.27,6.35,2.69Zm-39.6-33.91-.19-.22-.23.2-.5.82Zm3.49,7.87-6.1,2.39v.31l6.21-2.43Zm-.61-1.56-.11-.28-5.38,2.11v.32Zm-1.83,14.35.07-.29-3.73-.84v.3Zm.44-1.92.06-.29-4.16-.94v.3ZM145.72,419l.08-.28-3.73-.95v.31Zm-3.65-3,4.14,1.06.07-.29-4.21-1.07Zm4.62,8.93-.09-.28-4.53,1.49v.32Zm-.62-1.87-.09-.28-3.91,1.29v.31ZM203,365.26l.26.14,2.13-3.72H205Zm1.71,1,.26.14,2.69-4.7h-.34Zm-7.88-2-2.11-2.58h-.38l2.26,2.76Zm1.29-1.06.23-.19-1.08-1.33h-.39Zm-9.48,4.52-2.18-6h-.31l2.21,6.14Zm1.58-.57.28-.1-1.94-5.37h-.32Zm-14.3-2.21.29.07.84-3.33h-.3Zm1.91.49.28.07,1-3.82h-.31Zm-23.14-1.06.29.08.78-2.77h-.31Zm3.12-2.69h-.31l-.91,3.22.28.09Zm52.39,76.65,2.82,1.52v-.34l-2.68-1.44Zm1.08-2-.14.26,1.88,1v-.33ZM213,450.28v-.39l-2.8,2.42.2.22Zm0-2.6v-.39l-4.08,3.53.19.22Zm-.32,10.72.11.28.21-.08v-.32Zm-.72-1.83.11.28.93-.37v-.32Zm-2,10.31-.06.29,3.06.69v-.31Zm3-1.35-2.56-.58-.07.29,2.63.6ZM185.37,442.1l4.37,5.34.23-.19-4.37-5.33Zm3.07,6.4-4.37-5.33-.22.18,4.36,5.34ZM180.26,452l-2-5.58-.14.49,1.87,5.19Zm1.85-.67-2.34-6.49-.28.1,2.34,6.49Zm-4,7.51-.26-.15-3.43,6,.26.15Zm-2-1.12L174,461.5l-.33,1.17,2.77-4.84Zm27.81.16-.28-.07-1.7,6.68.29.07Zm1.92.48-.29-.07-1.7,6.69.29.07ZM194.68,464l-6.35-2.69-.12.27,6.35,2.69Zm.77-1.82-6.35-2.69-.12.27,6.35,2.7Zm-12.24,2.29,1.26,4.18h.31l-1.29-4.27Zm-1.6.48-.29.08,1.09,3.62h.31Zm19.59-13.4-.23-.19-4.33,5.36.23.19Zm-1.76-1.43-4.34,5.36.23.19,4.34-5.36Zm1.22-10.16-.3,0-.77,6.85.29,0Zm-2.26-.25-.77,6.85.3,0,.77-6.86Zm4.85-3.31,2.13-3.72H205l-2,3.57Zm4.06-3.72-2.61,4.55.26.15,2.69-4.7Zm-10.72,2.76.23-.19-2.11-2.57h-.38Zm1.52-1.25.23-.19-1.08-1.32h-.39Zm-9.48,4.52-2.18-6h-.31l2.21,6.13Zm1.58-.56.28-.11-1.94-5.36h-.32Zm-13.9-3.81.17.55.56-2.21h-.3Zm1.51,2.08.28.07,1-3.81h-.31Zm-36.07-48.91.11.28.21-.09v-.31Zm.32-2.24-1,.41.11.27.93-.36Zm-3.07,11,3.07.69v-.3l-3-.68Zm.44-1.92,2.63.59v-.3L139.5,394Zm2.63,23.44-3-.75-.07.29,3,.77Zm-2.47-2.66-.07.29,2.54.64v-.3Zm2.47,11.39v-.32l-2,.67.09.28Zm0-2.08v-.31l-2.64.87.09.28Zm-6.34,6-.25-.14-1.38,2.41h.34Zm1.71,1-.25-.15-.82,1.44h.34Zm-16.16-1.29,2.1,2.58h.39l-2.26-2.77Zm1.52-1.25,3.13,3.83h.38l-3.28-4Zm-5.6,2.71-.28.1.37,1h.32Zm-4.3-59.1,1,1.28-1-1.33Zm-6.21,2.23,2.35,6.48.27-.1L107,374.54Zm1.86-.67,2.34,6.48.28-.1-2.34-6.48ZM133,421.83l-6.35-2.69-.11.27,6.35,2.69Zm-.77,1.82-6.34-2.7-.12.28,6.35,2.69Zm.77-19.42-1.88,6.64.28.08,1.88-6.64Zm2.18.62-.29-.08-1.87,6.63.28.08Zm-10.17.71-2-6.6-.28.08,2,6.61Zm1.88-.57-2-6.6-.28.08,2,6.61Zm-19.72-17.12-.25-.15-3.43,6,.26.14Zm-1.71-1-.25-.15-3.43,6,.26.14ZM123.73,393l-6.35-2.69-.11.27,6.35,2.7Zm.77-1.81-6.35-2.69-.11.27,6.35,2.69Zm-11.94,31.16,6.83-1,0-.29-6.83,1Zm.28,1.95,6.83-1,0-.29-6.83,1Zm5-8.4.29.06,1.54-6.72-.29-.07Zm3.46-6.29-1.54,6.73.29.06,1.54-6.72Zm-18.8-11.9-2.63,1.15.1.28,2.65-1.16Zm.78,1.81-2.77,1.21.1.28,2.79-1.22Zm9-6,2,6.61.29-.09-2-6.6Zm-1.89.57,2,6.6.29-.08-2-6.6Zm-15.1-12.79.18.23,5.51-4.15-.18-.24Zm6.88-2.35-.18-.23-5.51,4.15.18.24Zm10.41,33.91-6.35-2.69-.12.27,6.35,2.69Zm-5.7-4.24,6.35,2.69.12-.27L107,408.3Zm32.52,29.5-.14.26.25-.2Zm.93-1.73-.14.26.73.39.24-.21ZM129,443.61h.3l.41-3.7-.29,0Zm-2-.34.29.09.41-3.67-.29,0Zm7.39-10.64h-.34l-2,3.57.25.15Zm2.27,0h-.34l-2.61,4.55.26.15Zm-11.06,2.76.22-.19-2.1-2.57h-.39Zm1.52-1.25.23-.19-1.09-1.32h-.38Zm-9.88-1.51,1.43,4,.55.64-1.66-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: "0.9853323101997375px"
    },
    d: "M200.16,327s-16.24-2.26-23.74,2.59-44.56,68.19-44.56,68.19l-20.47-27.55L93.64,378.2s8.32,32.2,18,48.22,15.2,17.64,18.52,17.11c9.88-1.57,38.5-34.68,38.5-34.68l10.4,34.6L172,468.6H303.5L287.55,442s20.81-96,15.51-106.17S266.88,327,257.17,327h-27.8a69.3,69.3,0,0,1-12.79,1.32A161.22,161.22,0,0,1,200.16,327Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    d: "M168.67,408.85a43.23,43.23,0,0,1-4.25-24.61c1.93-13.47,10.27-28.22,10.27-28.22s-16.64,24-16.64,32S163,407.72,163,407.72l-4.32,12.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    d: "M213.93,313.73l.44,14.12-11.91.44S200,380.1,210.6,389.37,253.2,327,253.2,327l-11-2.21-3.53-28.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    points: "239.94 301.71 214.47 325.71 214.47 317.22 239.94 301.71"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    d: "M210.6,389.37s1.28-8.34,7.69-19.24"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    d: "M208.8,234.11l-29,30.15a56.72,56.72,0,0,1,3.26,20c-.34,10.68,9.37,26.39,17.31,33.69s24.14-3.92,30.19-7.88a76,76,0,0,0,11.25-9.32,13.06,13.06,0,0,0,10.78-6.58S210.45,249.14,208.8,234.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    d: "M200.94,265.07a20.14,20.14,0,0,1,1.92,6.5c.09,2.79-4.8,15.86-4.1,16.73s2.89,3.75,4.6,3.38"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.4926661550998688px"
    },
    d: "M213,279.36a18.69,18.69,0,0,1,12.7-.15"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.4926661550998688px"
    },
    d: "M190.43,280.4a25.25,25.25,0,0,1,6.71-.94"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M197.28,257.68a7.29,7.29,0,0,0-6,2.44c-2.51,2.89-3.73,5.41-4.36,3.37s2.17-5.79,3.16-6.55S195.71,253.2,197.28,257.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M209.69,256a18.64,18.64,0,0,1,8.47,2c3.83,2.1,2-2.16-.69-3.38S210.12,253.52,209.69,256Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    d: "M254.09,306.15c.18,3-1.37,5.5-3.44,5.62s-3.9-2.2-4.08-5.18,1.07-10.67,3.14-10.79S253.92,303.16,254.09,306.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M196.09,275c.14,2-.62,3.62-1.69,3.69s-2-1.46-2.17-3.42.62-3.62,1.69-3.69S196,273.08,196.09,275Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M217.67,274.23c.14,2-.62,3.61-1.68,3.69s-2-1.46-2.18-3.43.63-3.61,1.69-3.68S217.54,272.27,217.67,274.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    d: "M203.22,297.37s5.09,1.63,12-4.28"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.9853323101997375px"
    },
    d: "M111.39,370.25l-9.31-12.47c-.43-3.32-1.26-10.18-1.4-14.81-.19-6.3.12-10.15-3.46-15.74s-13.57-14.42-14.51-16.47-3.66,3.73-1.95,7.48,3.27,4.9,3.27,4.9-18.39-9.14-19-7.65,8.56,27.84,12.76,34.79c1.75,2.9,6.6,6.78,8.94,10.14a31.21,31.21,0,0,1,2.93,5.27c2.18,9.27,4.72,19.47,6,19.84C98.57,386.38,110.92,386.58,111.39,370.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.9853323101997375px"
    },
    d: "M85.25,341.6h0a1.32,1.32,0,0,1-1.62-.94L69,286.57A1.32,1.32,0,0,1,69.9,285h0a1.33,1.33,0,0,1,1.62.93L86.19,340A1.33,1.33,0,0,1,85.25,341.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.9853323101997375px"
    },
    d: "M74.7,307.19s-14.12,7.46-13.25,8.92,3.45,6.67,4.63,6.55,9.75-7.12,10.37-8S74.7,307.19,74.7,307.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.9853323101997375px"
    },
    d: "M77.22,316.35S65.49,325,65.87,326.26,72,342.43,73,343.64s10.18-3,10.18-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.9853323101997375px"
    },
    d: "M79,324.39s-11.23,8.82-10.49,9.1"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.9853323101997375px"
    },
    y2: 339.48,
    x2: 71.68,
    y1: 333.95,
    x1: 81.12
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.9853323101997375px"
    },
    d: "M84,323.14l5.18,5.06S82.3,342.89,88.89,351"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M288.39,330.13s12.57-1.64,18,8.75,39.36,102.22,39.91,111-22.42,10.93-30.07,7.11-29-49.2-31.16-55.22"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    transform: "matrix(0.27, -0.96, 0.96, 0.27, -168.86, 571.2)",
    height: 0.3,
    width: 6.9,
    y: 397.06,
    x: 289.65
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "296.73 375.04 294.82 368.41 294.53 368.5 296.45 375.12 296.73 375.04"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    transform: "translate(-168.16 572.97) rotate(-74.16)",
    height: 0.3,
    width: 6.9,
    y: 397.59,
    x: 291.55
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "298.69 390.03 294.32 384.69 294.09 384.88 298.46 390.21 298.69 390.03"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    transform: "translate(-133.98 155.21) rotate(-23.57)",
    height: 0.3,
    width: 6.9,
    y: 398.57,
    x: 301.56
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "307.53 405.14 307.28 404.98 303.59 410.81 303.84 410.97 307.53 405.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "292.64 369.04 294.55 375.67 294.84 375.58 292.92 368.96 292.64 369.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "301.92 409.75 302.17 409.91 305.86 404.09 305.61 403.93 301.92 409.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "300.21 388.78 295.85 383.44 295.62 383.63 299.98 388.96 300.21 388.78"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    transform: "translate(-166.42 258.67) rotate(-36.93)",
    height: 0.3,
    width: 6.9,
    y: 378.4,
    x: 300.7
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "305.44 346.97 307.43 353.58 307.71 353.49 305.73 346.89 305.44 346.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "305.81 375.02 305.63 374.78 300.12 378.93 300.3 379.17 305.81 375.02"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M302.17,339l2.07-3.27c-.07-.07-.13-.15-.2-.23l-2.12,3.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "296.12 351.45 296.36 351.63 300.55 346.15 300.32 345.97 296.12 351.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "299.88 360.44 306.23 363.13 306.35 362.86 300 360.17 299.88 360.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "307.33 346.4 309.32 353.01 309.6 352.92 307.62 346.32 307.33 346.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "306.91 390.56 310.34 384.57 310.08 384.43 306.66 390.41 306.91 390.56"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    transform: "translate(-150.33 499.86) rotate(-67.01)",
    height: 6.9,
    width: 0.29,
    y: 360.02,
    x: 302.2
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    transform: "translate(-133.3 154.7) rotate(-23.56)",
    height: 0.3,
    width: 6.9,
    y: 396.77,
    x: 300.77
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M323,457.13l-.11.27,3.19,1.36h.78Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "324.38 435.68 322.44 430.31 322.04 429.2 321.76 429.3 322.13 430.31 324.1 435.78 324.38 435.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "317.74 441.04 322.11 446.38 322.33 446.19 317.97 440.85 317.74 441.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "322.52 436.35 320.35 430.31 320.18 429.87 319.91 429.96 320.03 430.31 322.25 436.45 322.52 436.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "324.46 420.74 317.63 421.7 317.67 421.99 324.5 421.03 324.46 420.74"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M344.3,450.22l1.85-1.6-.06-.33-2,1.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "294.56 350.25 294.79 350.43 298.99 344.95 298.75 344.77 294.56 350.25"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    transform: "translate(-115.27 120.86) rotate(-19.85)",
    height: 6.9,
    width: 0.3,
    y: 386.36,
    x: 287.57
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M343,448.73l2.64-2.28a3,3,0,0,1-.08-.32l-2.75,2.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "323.86 444.94 319.49 439.61 319.26 439.79 323.63 445.13 323.86 444.94"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    transform: "translate(-100.32 638.1) rotate(-86.67)",
    height: 0.3,
    width: 6.9,
    y: 372.06,
    x: 284.52
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "319.37 397.68 317.39 391.08 317.1 391.16 319.09 397.77 319.37 397.68"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    transform: "translate(-108.54 129.04) rotate(-19.84)",
    height: 6.9,
    width: 0.29,
    y: 371.4,
    x: 314.55
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "312.66 359.37 311.71 363.12 312 363.19 312.97 359.37 313.7 356.5 313.41 356.43 312.66 359.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "310.63 359.37 309.8 362.63 310.09 362.7 310.93 359.37 311.79 356.02 311.5 355.95 310.63 359.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "315.21 391.73 317.2 398.33 317.48 398.25 315.5 391.64 315.21 391.73"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    transform: "translate(-108.93 128.55) rotate(-19.85)",
    height: 6.9,
    width: 0.29,
    y: 372.07,
    x: 312.69
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    transform: "translate(-114.87 121.36) rotate(-19.84)",
    height: 6.9,
    width: 0.3,
    y: 385.69,
    x: 289.42
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M303.84,340l1.68-2.65-.18-.28-1.75,2.78Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "311.71 406.26 318.06 408.95 318.17 408.68 311.82 405.99 311.71 406.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "294.26 334.94 294 334.79 290.57 340.77 290.83 340.92 294.26 334.94"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M341,431.3l-.13-.37-2.25,3.94.25.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "334.55 437.6 334.26 437.57 333.48 444.42 333.78 444.45 334.55 437.6"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    transform: "translate(-183.27 563.42) rotate(-67.01)",
    height: 6.9,
    width: 0.29,
    y: 416.68,
    x: 333.73
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M339.27,430.31l.87-1.51-.12-.38-1.09,1.89-2.05,3.58.26.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "335.1 449.19 334.87 449 330.53 454.36 330.76 454.55 335.1 449.19"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M336.81,419.07l-5.28-2.24-.11.27,5.52,2.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "333.56 447.95 333.33 447.76 329 453.12 329.23 453.31 333.56 447.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "326.42 407.37 326.13 407.3 324.59 414.02 324.88 414.09 326.42 407.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "330.48 433.08 330.71 432.89 328.6 430.31 326.34 427.55 326.11 427.74 328.22 430.31 330.48 433.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "292.28 341.75 292.54 341.9 295.97 335.91 295.71 335.77 292.28 341.75"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    transform: "translate(-133.02 132.76) rotate(-19.85)",
    height: 6.9,
    width: 0.29,
    y: 443.01,
    x: 312.69
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M337.9,455.54l-.29-.08-.53,2.08.33-.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    transform: "translate(-132.61 133.25) rotate(-19.84)",
    height: 6.9,
    width: 0.29,
    y: 442.34,
    x: 314.55
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M322.88,386.46l2.64,1.12c0-.13-.1-.26-.14-.38l-2.39-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M339.81,456l-.29-.07-.24.93.34-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M305.58,435.62l-5.24-2.22.22.41,4.9,2.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "287.67 345.76 291.08 349.31 291.3 349.11 287.69 345.36 287.67 345.76"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M317.74,370.1l2.34,2.85-.33-.86L318,369.91Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "289.66 350.68 289.87 350.47 287.57 348.07 287.55 348.48 289.66 350.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "327.61 396.73 329.6 403.34 329.88 403.25 327.9 396.65 327.61 396.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "306.35 433.81 300 431.11 299.88 431.38 306.23 434.08 306.35 433.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "298.99 415.9 298.75 415.72 294.56 421.19 294.79 421.37 298.99 415.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "309.6 423.87 307.62 417.26 307.33 417.35 309.32 423.95 309.6 423.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "307.71 424.44 305.73 417.83 305.44 417.92 307.43 424.52 307.71 424.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "300.55 417.09 300.32 416.92 296.12 422.39 296.36 422.57 300.55 417.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "290.47 362.59 290.76 362.67 291.69 359.37 292.63 356.04 292.35 355.95 291.38 359.37 290.47 362.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "289.33 359.37 288.57 362.06 288.86 362.14 289.64 359.37 290.73 355.5 290.45 355.42 289.33 359.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "294.26 405.88 294 405.73 290.57 411.72 290.83 411.86 294.26 405.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "295.97 406.86 295.71 406.71 292.28 412.7 292.54 412.84 295.97 406.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "311.8 385.41 308.37 391.39 308.62 391.54 312.05 385.55 311.8 385.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "324.21 406.86 322.67 413.58 322.96 413.65 324.5 406.93 324.21 406.86"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M326.31,389.73,322.22,388l-.11.27,4.34,1.84C326.4,390,326.36,389.86,326.31,389.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "324.23 419.08 324.19 418.79 317.36 419.75 317.4 420.04 324.23 419.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "327.87 426.3 327.64 426.49 330.77 430.31 332.01 431.83 332.24 431.64 331.15 430.31 327.87 426.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "312.97 430.31 313.7 427.45 313.41 427.38 312.66 430.31 311.71 434.06 312 434.13 312.97 430.31"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    transform: "translate(-185.31 538.67) rotate(-67.01)",
    height: 6.9,
    width: 0.29,
    y: 405.84,
    x: 314.02
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "310.93 430.31 311.79 426.96 311.5 426.89 310.63 430.31 309.8 433.57 310.09 433.65 310.93 430.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "331.82 444.23 332.59 437.38 332.3 437.35 331.52 444.2 331.82 444.23"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: "0.9853323101997375px"
    },
    d: "M288.39,330.13s12.57-1.64,18,8.75,39.36,102.22,39.91,111-22.42,10.93-30.07,7.11-29-49.2-31.16-55.22"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    d: "M212.4,455.32s-25.69-3.28-30.07-2.74-24.05,13.67-24.05,13.67H214Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2232a"
    },
    d: "M318.45,437.82l-106,17.5L214,466.25H344.7a95.88,95.88,0,0,0,1.64-16.4c0-8.2-4.92-17.49-4.92-17.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "327.23 455.87 329.22 462.47 329.5 462.39 327.52 455.78 327.23 455.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "334.49 437.19 330.15 442.55 330.38 442.74 334.72 437.38 334.49 437.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "328.62 441.31 328.85 441.5 333.18 436.14 332.95 435.95 328.62 441.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "314.83 450.86 316.82 457.47 317.1 457.38 315.12 450.78 314.83 450.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "331.39 461.82 329.4 455.21 329.12 455.3 331.11 461.9 331.39 461.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "318.99 456.82 317.01 450.21 316.72 450.3 318.71 456.9 318.99 456.82"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    transform: "translate(-179.59 663.17) rotate(-75.75)",
    height: 0.3,
    width: 6.9,
    y: 446.89,
    x: 333.08
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "336.02 466.25 336.33 466.25 337.78 461.13 337.49 461.05 336.02 466.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "311.44 465.12 311.33 465.39 313.35 466.25 314.11 466.25 311.44 465.12"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    transform: "translate(-178.68 665.25) rotate(-75.74)",
    height: 0.3,
    width: 6.9,
    y: 447.37,
    x: 334.99
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    transform: "translate(-134.97 124.74) rotate(-19.84)",
    height: 6.9,
    width: 0.3,
    y: 444.82,
    x: 289.04
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "321.73 447.41 328.07 450.1 328.19 449.83 321.84 447.13 321.73 447.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "323.83 466 323.77 466.25 324.07 466.25 324.12 466.06 323.83 466"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    transform: "translate(-212.8 572.17) rotate(-67.01)",
    height: 6.9,
    width: 0.29,
    y: 443.35,
    x: 325.58
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "293.71 444.01 298.08 449.35 298.31 449.16 293.94 443.82 293.71 444.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "299.83 447.91 295.46 442.58 295.24 442.76 299.6 448.1 299.83 447.91"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M342.63,436.92l.61-.53-.12-.29-.68.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    transform: "translate(-226.19 613.38) rotate(-74.16)",
    height: 0.3,
    width: 6.9,
    y: 456.19,
    x: 289.27
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M343.9,451.12l2.41.55c0-.1,0-.2,0-.3l-2.36-.54Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "306.9 464.12 305.55 466.25 305.9 466.25 307.15 464.27 306.9 464.12"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M346.24,453.37l-2.71-.61-.07.28,2.76.63C346.23,453.57,346.24,453.47,346.24,453.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M343.92,438.41l.07-.06-.11-.3-.15.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    transform: "translate(-156.97 159.47) rotate(-23.56)",
    height: 0.3,
    width: 6.9,
    y: 455.9,
    x: 300.39
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "305.48 463.22 305.23 463.06 303.21 466.25 303.56 466.25 305.48 463.22"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    transform: "translate(-225.31 615.65) rotate(-74.16)",
    height: 0.3,
    width: 6.9,
    y: 456.73,
    x: 291.17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    transform: "translate(-157.66 159.99) rotate(-23.57)",
    height: 0.3,
    width: 6.9,
    y: 457.71,
    x: 301.18
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "311.67 444.69 311.42 444.54 307.99 450.53 308.24 450.68 311.67 444.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "306.28 449.55 306.53 449.69 309.96 443.71 309.7 443.56 306.28 449.55"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    transform: "translate(-162.88 131.12) rotate(-23.56)",
    height: 0.3,
    width: 6.9,
    y: 455.9,
    x: 229.45
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "222.94 465.01 222.68 464.87 221.89 466.25 222.23 466.25 222.94 465.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "220.98 459.7 222.7 453.62 222.38 453.67 220.7 459.62 220.98 459.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "224.65 465.99 224.39 465.85 224.16 466.25 224.5 466.25 224.65 465.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "257.9 448.28 258.02 448.01 257.64 447.86 257.1 447.94 257.9 448.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "265.08 466.25 265.39 466.25 266.83 461.13 266.55 461.05 265.08 466.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "267.67 446.2 266.5 450.82 266.78 450.9 267.99 446.15 267.67 446.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "234.54 463.22 234.29 463.06 232.27 466.25 232.62 466.25 234.54 463.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "236.21 464.27 235.96 464.12 234.6 466.25 234.95 466.25 236.21 464.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "295.33 465.85 295.1 466.25 295.44 466.25 295.59 465.99 295.33 465.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "339.39 461.59 338.07 466.25 338.38 466.25 339.67 461.67 339.39 461.59"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    transform: "translate(-135.37 124.24) rotate(-19.85)",
    height: 6.9,
    width: 0.3,
    y: 445.49,
    x: 287.19
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "268.44 461.59 267.13 466.25 267.43 466.25 268.73 461.67 268.44 461.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "240.5 465.12 240.38 465.39 242.41 466.25 243.16 466.25 240.5 465.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "293.88 465.01 293.62 464.87 292.83 466.25 293.17 466.25 293.88 465.01"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    transform: "matrix(0.27, -0.96, 0.96, 0.27, -276.82, 547.83)",
    height: 0.3,
    width: 6.9,
    y: 456.73,
    x: 220.23
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "279.85 458.12 279.57 458.01 277.05 464.43 277.32 464.54 279.85 458.12"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    transform: "translate(-163.54 131.58) rotate(-23.56)",
    height: 0.3,
    width: 6.9,
    y: 457.71,
    x: 230.24
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "281.68 458.83 281.4 458.73 278.88 465.15 279.16 465.25 281.68 458.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "272.52 453.05 275.58 453.74 279.24 454.56 279.31 454.27 275.58 453.43 272.58 452.76 272.52 453.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "279.68 452.64 279.75 452.35 275.58 451.41 273.02 450.83 272.95 451.12 275.58 451.71 279.68 452.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "264.88 450.41 265.87 446.5 265.55 446.55 264.59 450.34 264.88 450.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "257.25 449.83 254.01 448.45 253.47 448.54 257.13 450.1 257.25 449.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "247.76 456.9 248.05 456.82 246.06 450.21 245.78 450.3 247.76 456.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "246.16 457.38 244.17 450.78 243.89 450.86 245.88 457.47 246.16 457.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "256.29 455.87 258.28 462.47 258.56 462.39 256.57 455.78 256.29 455.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "252.88 466 252.82 466.25 253.13 466.25 253.17 466.06 252.88 466"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "260.45 461.82 258.46 455.21 258.18 455.3 260.16 461.9 260.45 461.82"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: "0.9853323101997375px"
    },
    d: "M318.45,437.82l-106,17.5L214,466.25H344.7a95.88,95.88,0,0,0,1.64-16.4c0-8.2-4.92-17.49-4.92-17.49"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    d: "M341.76,464.48H210L205.68,392a4.93,4.93,0,0,1,4.86-5.74H341.2a4.92,4.92,0,0,1,4.86,5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    d: "M216.47,388H340.25a4.8,4.8,0,0,1,4.79,5.56"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    d: "M206.66,392.45A4.82,4.82,0,0,1,211.5,388"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    height: 7.06,
    width: 132.88,
    y: 457.42,
    x: 209.43
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    d: "M284.82,425.66c0,3.12-4.22,5.65-9.42,5.65s-9.41-2.53-9.41-5.65,4.22-5.65,9.41-5.65S284.82,422.54,284.82,425.66Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mug--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    d: "M78.94,457.2a22.65,22.65,0,0,1-8.09-1.93,2.8,2.8,0,0,1,2.21-5.14c2.58,1.1,5.89,1.78,6.78,1.4,1.62-1.83,4.13-12.88.89-18.15a2.56,2.56,0,0,0-1.85-1.45c-1.84-.25-4.56,1.64-5.52,2.54a2.8,2.8,0,0,1-3.82-4.09c.51-.48,5.15-4.65,10.08-4a8.09,8.09,0,0,1,5.87,4.06C90.26,438.2,87,453,83.33,455.9A6.94,6.94,0,0,1,78.94,457.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    height: 40.95,
    width: 30.85,
    y: 424.1,
    x: 43.14
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    d: "M45.94,421.86s0-3.41,6.25-6.82,9.66-8.52,6.25-18.18-2.84-16.48,4-22.17"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    d: "M47.36,385.51c.32-4.15,2.17-7.66,6-10.82"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    d: "M49.35,396.86a39.78,39.78,0,0,1-1.51-5.28"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    d: "M71.32,400.19a25.07,25.07,0,0,0-.95-3.33l-.52-1.54"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9853323101997375px"
    },
    d: "M57.87,421.86s0-3.41,6.25-6.82c4.1-2.24,7-5.21,7.51-9.71"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#263238"
    },
    height: 10.3,
    width: 465.44,
    y: 464.35,
    x: 14.59
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginSvg);
export default __webpack_public_path__ + "static/media/loginSvg.ef6fb5c8fa46fea303c54479175fb94e.svg";
export { ForwardRef as ReactComponent };